import styled from 'styled-components';
import Imgix from 'shared/components/imgix';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const Summary = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey[90]};
  border-bottom: none;
`;

export const Section = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[90]};
  padding: 24px;
`;

export const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const SectionTitle = styled.h3`
  color: #4b5257;
  font-size: 16px;
  font-weight: 700;
  line-height: ${20 / 16};
`;

export const SummaryItems = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SummaryItem = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const SummaryItemLabel = styled.dt`
  width: 120px;
  flex-shrink: 0;
`;

export const SummaryItemValue = styled.dd`
  flex: 1;
  word-break: break-word;
`;

export const EditButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.primaryBlue};
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  padding: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ImagePreview = styled(Imgix)`
  max-width: 300px;
  border: 1px solid ${({ theme }) => theme.colors.grey[90]};
  border-radius: 4px;
`;

export const ScheduleDateContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ScheduleDate = styled.div`
  width: 91px;
`;

export const ScheduleTime = styled.div`
  margin-left: 16px;
`;

export const DayContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DayRow = styled.div`
  display: flex;
  align-items: left;
  justify-content: left;
`;

export const DayName = styled.div`
  width: 44px;
  font-size: 13px;
  font-style: normal;
`;

export const Hours = styled.div`
  margin-left: 16px;
`;
